import vue       from 'vue';
import { default as Component } from 'vue-class-component';

@Component({
  template: require('./app-footer.html'),
})
export class AppFooter extends vue {

  get chat(){
    if (process.env.ENV === 'development'){
      return false;
    }
    return true;
  }
  get copyrightYear(){
    const today = new Date();
    return today.getFullYear();
  }
}
